import { render, staticRenderFns } from "./NhapLieuCtyTTTaiChinh.vue?vue&type=template&id=10598a7d&scoped=true"
import script from "./NhapLieuCtyTTTaiChinh.vue?vue&type=script&lang=ts"
export * from "./NhapLieuCtyTTTaiChinh.vue?vue&type=script&lang=ts"
import style0 from "./NhapLieuCtyTTTaiChinh.vue?vue&type=style&index=0&id=10598a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10598a7d",
  null
  
)

export default component.exports